// ScenarioToggle.jsx
import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

export default function ScenarioToggle({ value, onChange }) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, v) => v && onChange(v)}
      size="small"
      data-testid="scenario-toggle"
      sx={{
        background: "#FFFFFF",
        border: "1px solid #E2E8F0",
        "& .MuiToggleButton-root": {
          textTransform: "none", fontWeight: 600, fontSize: 12, px: 1.6, py: 0.6,
          border: "none", color: "#4B5563", fontFamily: "IBM Plex Mono, monospace",
          "&.Mui-selected": { background: "#1E2A38", color: "#FFFFFF", "&:hover": { background: "#0F1721" } },
        },
      }}>
      <ToggleButton value="current" data-testid="scenario-current">Current</ToggleButton>
      <ToggleButton value="2030" data-testid="scenario-2030">2030</ToggleButton>
      <ToggleButton value="2050" data-testid="scenario-2050">2050</ToggleButton>
    </ToggleButtonGroup>
  );
}
